import { useRef, useState, createElement } from 'react';
import TaskInfoPane from './taskInfoPane';
import './index.scss';
const Pane = ({ onMounseMove }) => {
    const [height, setHeight] = useState(100);
    const footerRef = useRef({});
    const onMouseDown = (e) => {
        let draggable = true;
        let fitstY = e.pageY;
        const rootClientHeight = document.getElementById('root')?.clientHeight;
        const herderClicentHeight = document.getElementsByClassName('bpmn-header')[0]?.clientHeight;
        const footerHeight = footerRef.current?.clientHeight;
        const maxHeight = rootClientHeight - herderClicentHeight;
        document.onmousemove = (event) => {
            if (draggable) {
                let height = fitstY - event.pageY + footerHeight;
                if (height < 300) {
                    height = 300;
                }
                else if (height > maxHeight) {
                    height = maxHeight;
                }
                setHeight(height);
                onMounseMove(height);
            }
        };
        document.onmouseup = () => {
            fitstY = 0;
            draggable = false;
        };
    };
    const getHeight = () => {
        return `${height}px`;
    };
    return (createElement("div", { className: "bpmn-footer", style: { height: getHeight() }, ref: footerRef },
        createElement("div", { className: "draggable-line", onMouseDown: onMouseDown }),
        createElement("div", { className: "properties-wrapper" },
            createElement(TaskInfoPane, null))));
};
export default Pane;
